module.exports = __webpack_public_path__ + "static/media/bflash.47792ed5.png";